import { ICategory, IHobby, ISkill, ISubject } from '@wot/typings';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import categoryApi from '../../../../api/categories';
import LoadingContent from '../../../../components/LoadingContent';
import EditHobby from './EditHobby';
import EditSkill from './EditSkill';
import EditSubject from './EditSubject';

export default function EditCategory() {
  const [category, setCategory] = useState<ICategory<ISubject | IHobby | ISkill>>();
  const { _id } = useParams();

  useEffect(() => {
    if (_id) {
      categoryApi
        .getCategoryById(_id)
        .then((data) => {
          setCategory(data);
        })
        .catch((err) => err);
    }
  }, [_id]);

  if (!category) {
    return <LoadingContent />;
  }

  return (
    <div className="w-full h-full">
      {category.type === 'subject' && <EditSubject cat={category.category as ISubject} />}
      {category.type === 'hobby' && <EditHobby cat={category.category as IHobby} />}
      {category.type === 'skill' && <EditSkill cat={category.category as ISkill} />}
    </div>
  );
}
